import axios from '../utils/axios';
import Constants from './types';
import { getSessionId, getPayloadFromError } from '../utils';

export const clusterRecordLinks = (entityVersionId, recordId) => {
  const sessionId = getSessionId();

  const params = {
    entityId: entityVersionId,
    state: 'A',
    direct: 'N'
  };

  return dispatch => {
    dispatch(findRecordLinksRequest());
    axios({
      method: 'get',
      url: `/openempi-ws-rest/1.0/record-links/record/${recordId}`,
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params
    })
      .then(res => {
        dispatch(findRecordLinksSuccess(res.data));
      })
      .catch(err => {
        dispatch(findRecordLinksFailure(err));
      });
  };
};

export const manuallyClassifyLink = (entityVersionId, recordLink) => {
  const sessionId = getSessionId();
  return dispatch => {
    axios({
      method: 'PUT',
      url: '/openempi-ws-rest/1.0/record-links/' + recordLink.recordLinkId,
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: {
        entityId: entityVersionId
      },
      data: recordLink
    })
      .then(res => {
        dispatch(manuallyClassifyLinkSuccess(res.data));
      })
      .catch(err => {
        dispatch(manuallyClassifyLinkFailure(err));
      });
  };
};

export const deleteRememberedLink = (entityVersionId, recordLink) => {
  const sessionId = getSessionId();
  return dispatch => {
    axios({
      method: 'DELETE',
      url: '/openempi-ws-rest/1.0/record-links/' + recordLink.recordLinkId,
      headers: {
        Accept: 'application/json',
        OPENEMPI_SESSION_KEY: sessionId
      },
      params: {
        entityId: entityVersionId
      }
    })
      .then(res => {
        dispatch(deleteRememberedLinkSuccess(res.data));
      })
      .catch(err => {
        dispatch(deleteRememberedLinkFailure(err));
      });
  };
};

export const clearClusterLinksError = () => {
  return {
    type: Constants.CLUSTER_CLEAR_ERRORS
  };
};

const findRecordLinksRequest = () => {
  return {
    type: Constants.CLUSTER_RECORDLINKS_REQUEST
  };
};

const findRecordLinksSuccess = data => {
  return {
    type: Constants.CLUSTER_RECORDLINKS_SUCCESS,
    payload: data
  };
};

const findRecordLinksFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.CLUSTER_RECORDLINKS_FAILURE,
    payload
  };
};

const manuallyClassifyLinkSuccess = data => {
  return {
    type: Constants.CLUSTER_CLASSIFY_SUCCESS,
    payload: data
  };
};

const manuallyClassifyLinkFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.CLUSTER_CLASSIFY_FAILURE,
    payload
  };
};

const deleteRememberedLinkSuccess = data => {
  return {
    type: Constants.CLUSTER_DELETELINK_SUCCESS,
    payload: data
  };
};

const deleteRememberedLinkFailure = err => {
  const payload = getPayloadFromError(err);
  return {
    type: Constants.CLUSTER_DELETELINK_FAILURE,
    payload
  };
};
